import { Box, Button, Dialog, TextField } from "@mui/material";
import { useState } from "react";
import "../styles/runOnDataDialog.css";
import { PopupModal } from "react-calendly";

type RunOnDataDialogProps = {
    isDialogOpen: boolean;
    closeDialog: () => void;
}

const RunOnDataDialog: React.FC<RunOnDataDialogProps> = ({
    isDialogOpen,
    closeDialog
}) => {
    const[workEmail, setWorkEmail] = useState("");
    const[useCase, setUseCase] = useState("");
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [shouldOpenCalendly, setShouldOpenCalendly] = useState(false);

    const submitPromptForm = async() => {
        await fetch('https://hooks.zapier.com/hooks/catch/3569491/3ubnhvy/', {
            method: 'POST',
            body: JSON.stringify({
                workEmail: workEmail,
                usecase: useCase,
                page: window.location.href,
            })
        }).catch((e) => {
            console.error("error in submitting prompt form", e);
        });
    }

    const checkAndSubmitForm = async() => {
        setIsSubmitButtonClicked(true);
        if(!workEmail || !validateEmail(workEmail) || !useCase) {
            setTimeout(() => {
                setIsSubmitButtonClicked(false);
            }, 3000);
            return;
        }
        await submitPromptForm();
        setIsSubmitButtonClicked(false);
    }

    const validateEmail = (email: string) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    return <Dialog open={isDialogOpen} onClose={closeDialog} id="dialog">
        <Box sx={{ padding: 2, display: "flex", flexDirection: "column", alignItems: "center", fontSize: 14, width: "500px" }}>
            <Box sx={{ marginBottom: 3, marginTop: 2, fontWeight: 600 }}>Get access right now for $100</Box>
            <Button variant="contained" sx={{ background: "#556fff", color: "white", textTransform: "capitalize" }}
                id={"earlyAccessButton"}
                onClick={() => {
                    setShouldOpenCalendly(true);
                }}
            >
                Get Early Access
            </Button>
            <PopupModal
                url="https://calendly.com/d/2c5-22m-m66/nanonets-workflowgpt?month=2023-04"
                onModalClose={() => setShouldOpenCalendly(false)}
                open={shouldOpenCalendly}
                rootElement={document.getElementById("root") as HTMLElement}
            />
            <Box sx={{ marginTop: 3, display: "flex", alignItems: "center" }}>
                <Box component={"span"} sx={{ fontSize: 12, textDecoration: "line-through", color: "#6c757d" }}>Standard pricing $499</Box>
                <Box component={"span"} sx={{ fontWeight: 600, marginLeft: "4px" }}>Early access $100</Box>
            </Box>
            <Box sx={{ position: "relative", margin: "24px 0", width: "100%" }}>
                <hr className="horizontalLineAroundOr"/>
                <Box className="orWithLine">OR</Box>
            </Box>
            <Box sx={{ fontWeight: 600, margin: "8px 0" }}>Tell the AI how you will use Workflow AI</Box>
            <Box sx={{ fontSize: 12, color: "#6c757d" }}>Enter a use case & if the AI likes it, you receive immediate access.</Box>
            <TextField
                placeholder="Your work email*"
                value={workEmail}
                onChange={(e) => setWorkEmail(e.target.value)}
                size="small"
                fullWidth
                inputProps={{
                    style: { fontSize: 14 }
                }}
                sx={{ margin:"8px 0" }}
                error={isSubmitButtonClicked && (!workEmail || !validateEmail(workEmail))}
                type={"email"}
                helperText={isSubmitButtonClicked && (!workEmail || !validateEmail(workEmail)) ? "Enter valid email" : ""}
            />
            <TextField
                placeholder="Enter your use case prompt*"
                value={useCase}
                onChange={(e) => setUseCase(e.target.value)}
                fullWidth
                multiline
                minRows={4}
                inputProps={{
                    style: { fontSize: 14 }
                }}
                error={isSubmitButtonClicked && !useCase}
                helperText={isSubmitButtonClicked && !useCase ? "Entering use case is necessary to submit form" : ""}
            />
            <Button
                variant="contained"
                sx={{ background: "#556fff", color: "white", textTransform: "capitalize", margin: "8px 0" }}
                onClick={checkAndSubmitForm}
            >Submit</Button>
        </Box>
    </Dialog>
}

export default RunOnDataDialog;